import styled from 'styled-components';

export const ViewRoot = styled.div<{ $active: boolean }>`
  flex: 1;
  display: ${({ $active }) => ($active ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: auto;
`;

export const TodoPageFill = styled.div`
  width: 100%;
  height: calc(100% - 16px);
  min-height: 0;
  display: flex;
  flex-direction: column;

  #container {
    flex: 1;
    height: 100%;
    min-height: 0;
  }
`;
